import { RootState } from '@/app/rootReducer';
import type { ProductItem } from '@/api';

export const selectProductDetails = (
  state: RootState
): ProductItem | undefined => state.productDetails.details;
